export default __webpack_public_path__ + "static/media/red-x-circle.0a07bb0c.svg";